import { AdvancedReorderConfig } from "./advanced-reorder-config";
import { ItemOrders } from "./item-orders";

export class ProductOrders {
  listings: ItemOrders[] = [];
  productId: number;
  included: boolean;
  quantity: number = 0;
  days: number = 0;
  orderFor: number = 0;
  setting: AdvancedReorderConfig;
}